import { Component } from "@theme/component";
import { ThemeEvents } from "@theme/events";
import { StandardEvents, ProductSelectEvent } from "@shopify/events";
class ProductSkuComponent extends Component {
  requiredRefs = ["skuContainer", "sku"];
  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }
  /**
   * Handles product select event and updates the SKU.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    event.promise.then(({ detail }) => {
      if (!detail) return;
      const { newProduct, resource } = detail;
      if (newProduct) {
        this.dataset.productId = newProduct.id;
      }
      if (detail.productId && detail.productId !== this.dataset.productId) {
        return;
      }
      if (resource) {
        const variantSku = resource.sku || "";
        if (variantSku) {
          this.style.display = "block";
          this.refs.sku.textContent = variantSku;
        } else {
          this.style.display = "none";
          this.refs.sku.textContent = "";
        }
      }
    }).catch((error) => {
      if (error?.name !== "AbortError") console.warn("[product-sku] Event promise rejected:", error);
    });
  };
}
if (!customElements.get("product-sku-component")) {
  customElements.define("product-sku-component", ProductSkuComponent);
}
